import { Component } from '@angular/core';
import { ListItem } from '../../core/models/list-item';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';

@Component({
  selector: 'app-admin-site-list',
  template: `
    <irar-site-list [sites]="sites$ | async"></irar-site-list>
  `
})
export class AdminSiteListContainerComponent {
  sites$: Observable<ListItem[]>;

  constructor(private store: Store<fromRoot.State>) {
    this.sites$ = this.store.select(fromRoot.getSites);
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/admin-site-list.ts